import { CommerceProperty, CommercePropertyValue } from '@msdyn365-commerce/retail-proxy';

export const findPropertyByKey = (key: string, properties?: CommerceProperty[]): CommerceProperty | undefined =>
    properties?.find(({ Key }) => Key?.toUpperCase() === key?.toUpperCase());

export const updateOrAddProperty = (key: string, value: CommercePropertyValue, extensionProperties: CommerceProperty[]) => {
    if (extensionProperties) {
        const property = findPropertyByKey(key, extensionProperties);
        if (property) {
            property.Value = value;
        } else {
            extensionProperties.push({ Key: key, Value: value });
        }
    }
};

export const removePropertyByKey = (key: string, extensionProperties?: CommerceProperty[]) => {
    if (!extensionProperties) {
        return;
    }
    const idx = extensionProperties.findIndex(p => (p?.Key ?? '').toUpperCase() === key.toUpperCase());
    if (idx >= 0) {
        extensionProperties.splice(idx, 1);
    }
};

export const getBooleanProperty = (properties: CommerceProperty[] | undefined, key: string): boolean => {
    const prop = findPropertyByKey(key, properties);
    return prop?.Value?.BooleanValue === true;
};

export const getStringProperty = (properties: CommerceProperty[] | undefined, key: string): string | undefined => {
    const prop = findPropertyByKey(key, properties);
    return prop?.Value?.StringValue;
};
